import { signal } from '@preact/signals';

export const FormState = {
  formControlValues: {},
  sameAddress: signal(false),
  isProfileUploading: signal(false),
  isProfileUploadingCancel: signal(false),
  isProfileUploadingSubmit: signal(false),
};
